/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CustomizedResultAreaGeometry } from "./CustomizedResultAreaGeometry";
import {
  CustomizedResultAreaGeometryFromJSON,
  CustomizedResultAreaGeometryFromJSONTyped,
  CustomizedResultAreaGeometryToJSON,
  CustomizedResultAreaGeometryToJSONTyped,
} from "./CustomizedResultAreaGeometry";
import type { SubsetsEnum } from "./SubsetsEnum";
import {
  SubsetsEnumFromJSON,
  SubsetsEnumFromJSONTyped,
  SubsetsEnumToJSON,
  SubsetsEnumToJSONTyped,
} from "./SubsetsEnum";

/**
 * A type of `ModelSerializer` that uses
 * hyperlinked relationships with compound keys instead
 * of primary key relationships.  Specifically:
 * * A 'url' field is included instead of the 'id' field.
 * * Relationships to other instances are hyperlinks, instead of primary keys.
 * NOTE: this only works with DRF 3.1.0 and above.
 * @export
 * @interface PatchedCustomizedResultArea
 */
export interface PatchedCustomizedResultArea {
  /**
   *
   */
  readonly url?: string;
  /**
   * Name of the customized results area.
   */
  name?: string;
  /**
   * The subsets for which the customized results area is defined.
   */
  subsets?: Array<SubsetsEnum>;
  /**
   *
   */
  geometry?: CustomizedResultAreaGeometry;
}

/**
 * Check if a given object implements the PatchedCustomizedResultArea interface.
 */
export function instanceOfPatchedCustomizedResultArea(
  value: object
): value is PatchedCustomizedResultArea {
  return true;
}

export function PatchedCustomizedResultAreaFromJSON(json: any): PatchedCustomizedResultArea {
  return PatchedCustomizedResultAreaFromJSONTyped(json, false);
}

export function PatchedCustomizedResultAreaFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchedCustomizedResultArea {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    name: json["name"] == null ? undefined : json["name"],
    subsets:
      json["subsets"] == null
        ? undefined
        : (json["subsets"] as Array<any>).map(SubsetsEnumFromJSON),
    geometry:
      json["geometry"] == null ? undefined : CustomizedResultAreaGeometryFromJSON(json["geometry"]),
  };
}

export function PatchedCustomizedResultAreaToJSON(json: any): PatchedCustomizedResultArea {
  return PatchedCustomizedResultAreaToJSONTyped(json, false);
}

export function PatchedCustomizedResultAreaToJSONTyped(
  value?: Omit<PatchedCustomizedResultArea, "url"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
    subsets:
      value["subsets"] == null
        ? undefined
        : (value["subsets"] as Array<any>).map(SubsetsEnumToJSON),
    geometry: CustomizedResultAreaGeometryToJSON(value["geometry"]),
  };
}
